import React, { useEffect, useRef, useState } from 'react'
import { useOrderStore } from 'src/hooks/order';
import System from "../../../../helper/system";
import infoIcon from 'src/assets/images/info.svg';
import OrderHistoryDateFilter from '../Filters/OrderHistoryDateFilter';
import OrderHistorySearchFilter from '../Filters/OrderHistorySearchFilter';
import useReduxState from 'src/hooks/useReduxState';
import Helper from 'src/helper/Helper';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import stickyTableHeader from 'src/helper/stickyTableHeader';
import $ from 'jquery';
import Constants from 'src/helper/Constants';
import { useObjCommonFilterStore } from 'src/hooks/objCommonFilter';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import NavigateToProductDetail from 'src/component/custom/NavigateToProductDetail';
import Order from "@system/config/order";
import { Tooltip } from 'src/component/Global/Tooltip';
import store from "src/storeWire";
import { setOrderParams } from "src/store/slice/model/Order";
import Pagination from "src/component/Global/Pagination"
import { useSystem } from 'src/hooks/system';

const OrderHistoryListing = () => {
    const [__check] = useAxiosIndicatorCheck();
    const { translation: t } = System;

    const [{ order_list, product_specific_details }, { fetch_order_list, fetch_order_export_count, fetch_product_specific_details }, { export_order, order_download_invoice }] = useOrderStore();
    const [{ filter_list }, { }, { }] = useObjCommonFilterStore();
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [expandedRow, setExpandedRowT] = useState([])
    const [monitorFunctionCall, setMonitorFunctionCall] = useState({
        monitorJs: false,
        frameworkReady: false
    })
    const [filterOrderStatus] = useReduxState('', 'setFilterOrderStatus');
    const [dateRange] = useReduxState('', 'setDateRange');
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
    const [orderItemNumber, setOrderItemNumber] = useState([]);
    const [, { get_quantity_format }] = useSystem();
    const dropdownRef = useRef([]);
    const isAnyDropdownOpen = openDropdownIndex !== null;
    const [listObj, setListObj] = useState({
        pageCount: 0,
        page: 1,
        limit: 20,
        sortBy: '',
        sortOrder: '',
        ascDesField: {},
        total: 0
    })
    const { siteUser: { CORE }, speedBoats: { japanAbbr, apacAbbr }, orderStatus: { Shipped, PartiallyShipped } } = Constants
    const isCoreUser = System.getCurrentRegionWithType(apacAbbr, CORE)

    useEffect(() => {
        const getList = async () => {
            if (order_list.orderList?.length > 0) {
                const manufacturerList = []
                order_list.orderList?.map((value) => {
                    if (value && value.manufacturerName) {
                        manufacturerList.push(value.manufacturerName)
                    }
                });
            }
        };
        getList();

        if (order_list.orderList?.length > 0 && order_list.totalOrderList) {
            setTimeout(() => {
                $(".floating-table").floatingScroll("init");
            }, 2500)

            const totalPages = Math.ceil(order_list?.totalOrderList / listObj.limit);
            setListObj({ ...listObj, pageCount: totalPages });
        }
    }, [order_list]);

    const defaultPageActive = async () => {
        setListObj({ ...listObj, page: 1 });
    }

    const handlePageClick = async (data) => {
        let here_page = 0

        here_page = data.selected + 1;
        setListObj({ ...listObj, page: here_page })
        Helper.scrollTop();
    };

    const setPageLimit = async (event) => {
        setListObj({ ...listObj, limit: Number(event.target.value) });
    };

    useEffect(() => {
        const getList = async () => {
            await fetchAPICall();
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.page]);

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPICall()
            } else {
                await defaultPageActive()
            }
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.limit]);

    useEffect(() => {
        const getList = async () => {
            await fetchAPICall();
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.sortBy, listObj.sortOrder])

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPICall()
            } else {
                await defaultPageActive()
            }
            setExpandedRowT([])
        };
        getList()
    }, [filter_list])

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPICall()
            } else {
                await defaultPageActive()
            }
        };

        if (!(window.location.href.includes('salesOrderNum') && window.location.href.includes('POLineItemNumber'))) {
            getList()
        }
    }, [filterOrderStatus])

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPICall()
            } else {
                await defaultPageActive()
            }
        };
        setExpandedRowT([])

        getList()
    }, [dateRange])

    const fetchAPICall = async () => {
        let _deliveryDate = filter_list?.deliveryDate?.searchKeyword?.split("-");
        let _scheduleDate = filter_list?.scheduleDate?.searchKeyword?.split("-");

        const convertOrderDate = (dateStr) => {
            const [day, month, year] = dateStr?.trim().split('/').map(part => part.trim().padStart(2, '0'));
            return `${year}-${month}-${day}`;
        };

        const params = {
            filters: {
                "startDate": dateRange.split(';')[0],
                "endDate": dateRange.split(';')[1],
                "poNumber": filter_list?.poNumber?.searchKeyword?.trim(),
                "orderCreationType": filter_list?.orderType?.searchValue,
                "OrderNum": filter_list?.orderNumber?.searchKeyword?.trim(),
                "invoiceNum": filter_list?.invoiceNo?.searchKeyword?.trim(),
                "shippingTrackingNum": filter_list?.trackingNo?.searchKeyword?.trim(),
                "doNum": filter_list?.doNumber?.searchKeyword?.trim(),
                "sortBy": listObj.sortBy ? listObj.sortBy : 'FrontendOrderCreatedOn,BackendOrderCreatedOn',
                "sortOrder": listObj.sortOrder ? listObj.sortOrder : 'desc',
                "advancedFilters": {
                    "orderStatus": filter_list?.orderStatus?.searchKeywordArr?.map(item => item.value),
                    "atsStartDate": _deliveryDate ? convertOrderDate(_deliveryDate[0]) : "",
                    "atsEndDate": _deliveryDate ? convertOrderDate(_deliveryDate[1]) : "",
                    "crdStartDate": _scheduleDate ? convertOrderDate(_scheduleDate[0]) : "",
                    "crdEndDate": _scheduleDate ? convertOrderDate(_scheduleDate[1]) : "",
                    "mfrPartNumber": filter_list?.mfrPartNumber?.searchKeyword,
                    "manufacturer": filter_list?.manufacturer?.searchKeyword,
                    "custMatNum": filter_list?.custMatNum?.searchKeyword
                }
            },
            "startRow": listObj.page,
            "pageSize": Number(listObj.limit),
        }

        store.dispatch(setOrderParams(params))

        if (dateRange) {
            const result = await fetch_order_list(params)

            if (!monitorFunctionCall?.frameworkReady || !monitorFunctionCall?.monitorJs) {
                System.monitorFrameWorkReady()
                System.monitorJSDx()
                setMonitorFunctionCall({ ...monitorFunctionCall, frameworkReady: true, monitorJs: true })
            }

            if (result?.payload?.totalOrderList === 0) {
                const params = {
                    filters: {
                        sortBy: 'FrontendOrderCreatedOn,BackendOrderCreatedOn',
                        advancedFilters: {}
                    },
                    "startRow": 1,
                    "pageSize": 1,
                    "isIncludeSMREmail": false
                }
                await fetch_order_export_count(params)
            }
            await setFirstServerCall(false);
        }
    };

    const toggleOrderBy = async (columnName) => {
        if (listObj.ascDesField.hasOwnProperty(columnName)) {
            listObj.ascDesField[columnName] = listObj.ascDesField[columnName] === 'ASC' ? 'DESC' : 'ASC';
        } else {
            listObj.ascDesField[columnName] = 'ASC'
        }
        setListObj({ ...listObj, sortBy: columnName, sortOrder: listObj.ascDesField[columnName], ascDesField: listObj.ascDesField, page: 1 })
    };

    const getOrderByClass = (columnName) => {
        if (listObj.sortBy === columnName && listObj.ascDesField.hasOwnProperty(columnName)) {
            return 'sorting sorting_' + listObj.ascDesField[columnName].toLowerCase()
        }
        return 'sorting'
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        if (firstServerCall === false && !monitorFunctionCall) {
            System.monitorJSDx()
            setMonitorFunctionCall(true)
        }
    }, [order_list.orderList])

    useEffect(() => {
        if (product_specific_details && product_specific_details?.length > 0) {
            setOrderItemNumber(prevOrderItemList => [
                ...prevOrderItemList,
                ...product_specific_details
            ]);
        }
    }, [product_specific_details])

    const handleRowClick = async (item, azureOrderNum) => {
        const params = await item?.filter(e => e?.sapMaterial != null)?.map(e => e.sapMaterial)
        const filteredParams = params.filter(param =>
            !orderItemNumber.some(detail => detail.erpPartNumber === param)
        );

        if (filteredParams?.length > 0) {
            await fetch_product_specific_details(filteredParams)
        }

        setExpandedRowT(prevExpandedRow => {
            if (prevExpandedRow.includes(azureOrderNum)) {
                return prevExpandedRow.filter(row => row !== azureOrderNum);
            } else {
                return [...prevExpandedRow, azureOrderNum];
            }
        });
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current) {
                const isInsideDropdown = dropdownRef.current.some(dropdown => dropdown && dropdown.contains(event.target));
                if (!isInsideDropdown) {
                    setOpenDropdownIndex(null);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        let isDisplayFixedHeader = false;
        let refreshStockButton;
        let callback;
        const list = order_list?.orderList
        if (list && Object.keys(list).length > 0) {
            const sort = toggleOrderBy;
            // table elelment with unique id
            const tableElement = document?.getElementById("orderhistory-table");
            // headerHeght contains height where we need to display static header
            //local
            // const headerHeight =  document?.getElementsByTagName("header") ? document?.getElementsByTagName("header")[0]?.clientHeight :65;
            //sbx
            let headerHeight = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight + 1 : 65 + 1;
            // is used to track only one header will display at a moment

            // Admin Toolbar header height adjustment
            const adminToolBarHeight = document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")?.length > 0 ? document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")[0]?.clientHeight : 0;

            if (adminToolBarHeight > 0) {
                headerHeight = headerHeight + adminToolBarHeight;
            }

            document.addEventListener("scroll", (ScrollEvent) => {
                // current table position from top
                const tablePosition = tableElement ? tableElement?.getBoundingClientRect().y : false;
                const paginationPosition = document?.querySelectorAll("div.pagination-row") ? document?.querySelectorAll("div.pagination-row")[0]?.getBoundingClientRect().y : false;
                if (tablePosition && headerHeight > tablePosition && isNaN(paginationPosition) === false && (Number(headerHeight) + 40 <= Number(paginationPosition)) && !isDisplayFixedHeader) {
                    // function used to display header clone after actual header height is less than headerHeight from top
                    // function(id, headerHeight,  tableContainerId, noOfColummFixed, sort)
                    callback = stickyTableHeader("orderhistory-table", headerHeight, "sticky-table-wrapper", 3, sort)
                    // fixed header display now on ui
                    isDisplayFixedHeader = true
                } else {
                    if ((headerHeight < tablePosition || (Number(paginationPosition) <= Number(headerHeight) + 40)) && isDisplayFixedHeader && callback) {
                        // switch variable to false for track that clone header hide
                        isDisplayFixedHeader = false;
                        // function used to remove the clone header
                        if (Object.prototype.toString.call(callback) === '[object Function]') {
                            callback();
                        }
                    }
                }
            })
        }
        return () => {
            if (callback) {
                // switch variable to false for track that clone header hide
                isDisplayFixedHeader = false;
                // check element exist before remove event listeners
                if (refreshStockButton && refreshStockButton[1]) {
                    refreshStockButton[1]?.removeEventListener("click", refreshStock);
                }
                // function used to remove the clone header
                callback();
            }
        }

    }, [order_list.orderList, __check(['ORDER_API_CALL']).status]);

    const downloadInvoice = async (invoiceNumber, orderNumber = 0) => {
        if (System.getCurrentRegionWithType(japanAbbr)) {
            System.popup('OrderJapanInvoicePopup', {
                orderNumber: orderNumber,
                invoiceNumber: invoiceNumber
            })
        } else {
            const result = await order_download_invoice(invoiceNumber);
            if (result) {
                system_alert_indicator({
                    name: 'DownloadOrder',
                    message: t('downloadMsg'),
                    type: "success"
                })
            }
        }
    }

    const exportOrder = async (salesOrderNum, webOrderNum) => {
        await export_order({
            OrderId: webOrderNum,
            SalesOrderNumber: salesOrderNum
        })
        system_alert_indicator({
            name: 'ExportOrder',
            message: t('documentDownloadMessage'),
            type: "success"
        })
    }

    const renderKeyLegendTooltip = () => {
        return (
            <>
                <span className="text-uppercase">{t('orderReceived')}:</span> <br /> {t('orderReceivedTooltip')} <br /><br />
                <span className="text-uppercase">{t('orderInProcess')}:</span> <br /> {t('orderInProcessTooltip')} <br /><br />
                <span className="text-uppercase">{t('partiallyShipped')}:</span>  <br /> {t('partiallyShippedTooltip')} <br /><br />
                <span className="text-uppercase">{t('partiallyCancelled')}:</span>  <br /> {t('partiallyCancelledTooltip')} <br /><br />
                <span className="text-uppercase">{t('shipped')}:</span>  <br /> {t('shippedTooltip')} <br /><br />
                <span className="text-uppercase">{t('cancelled')}:</span>  <br /> {t('cancelledTooltip')}
            </>
        )
    }

    const toggleDropdown = (index) => {
        setOpenDropdownIndex(openDropdownIndex === index ? null : index);
    };

    const navigateToOrderDetail = (azureOrderNum) => {
        const orderDetails = {
            orderNumber: azureOrderNum,
        };

        window.location.href = Order.getOrderDetailRouteURL(orderDetails);
    }

    const getOrderItemDetails = (sapMaterial) => {
        const item = orderItemNumber.find(item => item.erpPartNumber === sapMaterial);
        return item
            ? {
                itemNumber: item.itemNumber,
                seoItemnumber: item.seoItemnumber,
                manufacturerPartNumber: item.manufacturerPartNumber,
                mfrPartNumber: item.mfrPartNumber,
            }
            : null;
    };

    const renderOrderItem = (v, val, processItem) => {
        return <>
            <td className='border-0'></td>
            {isCoreUser && (
                <td>
                    <div>
                        <a
                            href={void (0)}
                            onClick={() => System.popup('OrderHistoryEmailPopUp', {
                                singleOrder: {
                                    orderDate: v?.orderType === 'Online' ? v?.orderDate : v?.backendOrderCreatedOn,
                                    poNumber: v?.poNumber,
                                    webOrderNum: v?.webOrderNum,
                                    salesOrderNum: v?.salesOrderNum,
                                    smrEmail: order_list?.smrEmail,
                                    azureOrderNum: v?.azureOrderNum
                                },
                                singleProduct: {
                                    parentManufacturerName: val?.parentManufacturerName,
                                    mfrPartNumber: getOrderItemDetails(val?.sapMaterial)?.mfrPartNumber,
                                    custMatNum: val?.custMatNum,
                                    qty: val?.qty
                                }
                            })}
                            className="text-blue2 d-flex align-items-center"
                            data-toggle="modal"
                            data-target="#EmailMessage"
                        >
                            <i className="fa fa-envelope font-16 me-2"></i>
                        </a>
                    </div>
                </td>
            )}
            <td><div>{val.backendItemNum}</div></td>
            <td><span className="text-nowrap">{val.parentManufacturerName || ''}</span></td>
            <td>
                {getOrderItemDetails(val?.sapMaterial)?.seoItemnumber ? (
                    <NavigateToProductDetail
                        target="_blank"
                        data={{
                            ManufacturerName: val.parentManufacturerName,
                            ERPMFRPartNumber: getOrderItemDetails(val?.sapMaterial)?.mfrPartNumber,
                            ItemNumber: getOrderItemDetails(val?.sapMaterial)?.itemNumber,
                            ERPPartNumber: val.sapMaterial,
                            seoItemNumber: getOrderItemDetails(val?.sapMaterial)?.seoItemnumber
                        }}
                    >
                        <span className="text-nowrap text-blue2">{getOrderItemDetails(val?.sapMaterial)?.mfrPartNumber || ''}</span>
                    </NavigateToProductDetail>
                ) : (
                    <span className="text-nowrap">{getOrderItemDetails(val?.sapMaterial)?.mfrPartNumber || ''}</span>
                )}
            </td>
            {isCoreUser && <td><span className="text-nowrap">{val.custMatNum || ''}</span></td>}
            <td><span className="text-nowrap">{val.soItemStatus ? val.soItemStatus : ''}</span></td>
            <td><span className="text-nowrap">{get_quantity_format(val.qty)}</span></td>
            <td><span className="text-nowrap">{val.price ? System.getFormatNumber({ amount: Number(val.price), currency: System.getRegionCurrency() }) : ''}</span></td>
            <td><span className="text-nowrap">{val.totalAMT ? System.getFormatNumber({ amount: Number(val.totalAMT), maximumFractionDigits: 2, currency: System.getRegionCurrency(), roundOff: true }) : ''}</span></td>
            {isCoreUser && <td><span className="text-nowrap">{val.crdDate ? Helper.orderHistoryDateFormat(val.crdDate) : ''}</span></td>}
            {isCoreUser && <td><span className="text-nowrap">{get_quantity_format(val.scheduleLineQty) || ''}</span></td>}
            {!processItem && <><td></td><td> </td></>}
        </>
    }

    const displayTrackingNumber = (number, carrier) => {
        let carrierLink = ''

        if (carrier && System.getCurrentRegionWithType(japanAbbr)) {
            const carrierMethod = carrier?.split('|')[1] || ''
            carrierLink = carrierMethod !== '' ? System.getTrackingLink(carrierMethod) : ''
        }

        return carrierLink !== '' ? <a href={carrierLink} target='_blank'><span className='text-blue'>{number}</span></a> :
            <span className='text-black'>{number}</span>
    }

    return (
        <>
            <OrderHistoryDateFilter />
            {!firstServerCall && <OrderHistorySearchFilter />}
            {(__check('ORDER_API_CALL').status || order_list.orderList?.length > 0) &&
                <div className='position-relative'>
                    <div>
                        {__check(['ORDER_API_CALL'], { overlay: true }).render}
                    </div>
                    {
                        <div id="sticky-table-wrapper" className={`table-responsive m-t-15 floating-table sticky-table-wrapper ${isAnyDropdownOpen ? 'orderhistory-table-sticky' : ''}`}>
                            <table id="orderhistory-table" className="bs5 table table-bordered">
                                <thead>
                                    <tr>
                                        <th className='w155'></th>
                                        <th className='minw190'><span>{t('PONumber')}</span>
                                            <span aria-label="poNumber" aria-pressed="false" className={'sort-container ' +
                                                (getOrderByClass('CustomerPO'))
                                            }
                                                onClick={async () => {
                                                    await toggleOrderBy('CustomerPO')
                                                }}></span>
                                        </th>
                                        <th className='minw140'><span>{t('orderNumber')}</span>
                                            <span aria-label="salesOrderNum" aria-pressed="false" className={'sort-container ' +
                                                (getOrderByClass('BackendOrderNum'))
                                            }
                                                onClick={async () => {
                                                    await toggleOrderBy('BackendOrderNum')
                                                }}></span>
                                        </th>
                                        <th className='minw140'>
                                            {t('orderStatus')}

                                            <Tooltip
                                                position={'bottom center'}
                                                opener={() => (
                                                    <a className="customer-link" href={void (0)}><i className='ms-2'><img className="" src={infoIcon} alt='Information' /></i><span
                                                        className="bs5 text-blue"></span></a>
                                                )}
                                                content={() => (
                                                    renderKeyLegendTooltip()
                                                )}
                                            />
                                            <span aria-label="orderStatus" aria-pressed="false" className={'sort-container ' +
                                                (getOrderByClass('OrderStatus'))}
                                                onClick={async () => {
                                                    await toggleOrderBy('OrderStatus')
                                                }}></span>
                                        </th>
                                        <th className='minw120'>
                                            {t('trackingWayBillNumber')}
                                            <span aria-label="TrackingNumber" aria-pressed="false"></span>
                                        </th>
                                        <th className='minw120'>
                                            {t('invoiceNumber')}
                                            <span aria-label="InvoiceNumber" aria-pressed="false"></span>
                                        </th>
                                        <th className='minw120'>
                                            {t('orderDate')}
                                            <span aria-label="orderDate" aria-pressed="false" className={'sort-container ' +
                                                (getOrderByClass('FrontendOrderCreatedOn,BackendOrderCreatedOn'))}
                                                onClick={async () => {
                                                    await toggleOrderBy('FrontendOrderCreatedOn,BackendOrderCreatedOn')
                                                }}></span>
                                        </th>
                                        <th className='minw120'>
                                            {t('orderTotalPrice')}
                                            <span aria-label="orderTotal" aria-pressed="false" className={'sort-container ' +
                                                (getOrderByClass('TotalAMT'))}
                                                onClick={async () => {
                                                    await toggleOrderBy('TotalAMT')
                                                }}></span>
                                        </th>
                                        <th><span>{t('orderType')}</span>
                                            <span aria-label="orderType" aria-pressed="false" className={'sort-container ' +
                                                getOrderByClass('OrderCreationType')
                                            }
                                                onClick={async () => {
                                                    await toggleOrderBy('OrderCreationType')
                                                }}></span>
                                        </th>
                                        <th className='minw120'>
                                            {t('doNumber')}
                                            <span aria-label="doNumber" aria-pressed="false" className={'sort-container'}></span>
                                        </th>
                                        {isCoreUser &&
                                            <>
                                                <th className='minw120'>
                                                    {t('accountNumber')}
                                                    <span aria-label="accountNo" aria-pressed="false" className={'sort-container ' +
                                                        (getOrderByClass('billToCode'))}
                                                        onClick={async () => {
                                                            await toggleOrderBy('billToCode')
                                                        }}></span>
                                                </th>
                                                <th className='minw120'>
                                                    {t('buyer')}
                                                    <span aria-label="buyerName" aria-pressed="false" className={'sort-container ' +
                                                        (getOrderByClass('frontendOrderCreatedName'))}
                                                        onClick={async () => {
                                                            await toggleOrderBy('frontendOrderCreatedName')
                                                        }}></span>
                                                </th>
                                            </>}
                                    </tr>
                                </thead>
                                {order_list.orderList?.length > 0 &&
                                    <tbody>
                                        {order_list.orderList?.map((order, i) => {
                                            const v = order?.orderHeader
                                            return (
                                                <React.Fragment key={i}>
                                                    <tr className={expandedRow?.length > 0 && expandedRow.includes(v.azureOrderNum) ? 'align-middle bg-offwhite' : 'align-middle'}>
                                                        <td>
                                                            <div className='d-flex align-items-center'>
                                                                <div className="accordion-white-button">
                                                                    <div className="accordian-arrow">
                                                                        <i
                                                                            className={expandedRow.includes(v.azureOrderNum) ? 'fa fa-angle-double-up me-0 d-block' : 'fa fa-angle-double-down me-0 d-block'}

                                                                            onClick={() => handleRowClick(order?.orderItems, v.azureOrderNum)}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div ref={el => dropdownRef.current[i] = el} className={`dropdown selectbox w110 ms-3 ${openDropdownIndex === i ? 'open' : ''}`}>
                                                                    <a
                                                                        className="bs5 form-control form-control-sm text-black dropdown-control"
                                                                        onClick={() => toggleDropdown(i)}
                                                                        aria-expanded={openDropdownIndex === i}
                                                                    >
                                                                        <span>{t('options')}</span>
                                                                    </a>
                                                                    {openDropdownIndex === i && (
                                                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                            <li>
                                                                                <a
                                                                                    href={void (0)}
                                                                                    className="dropdown-item text-black"
                                                                                    onClick={() => {
                                                                                        setOpenDropdownIndex(null);
                                                                                        navigateToOrderDetail(v.azureOrderNum)
                                                                                    }}
                                                                                >
                                                                                    <i className='fa fa-eye'></i>
                                                                                    {t('viewOrderDetails')}
                                                                                </a>
                                                                            </li>
                                                                            <li>
                                                                                <a
                                                                                    href={void (0)}
                                                                                    className="dropdown-item text-black d-flex align-items-center"
                                                                                    onClick={() => {
                                                                                        setOpenDropdownIndex(null);
                                                                                        exportOrder(v?.salesOrderNum, v?.webOrderNum)
                                                                                    }}
                                                                                >
                                                                                    <i className="order-export-icon text-black-stone" aria-hidden="true"></i>
                                                                                    {t('exportThisOrder')}
                                                                                </a>
                                                                            </li>
                                                                            {v?.invoiceNumber?.length > 0 && (v.orderStatus?.trim() === 'Shipped' || v.orderStatus?.trim() === 'Partially Shipped') && (
                                                                                <li>
                                                                                    <a
                                                                                        href={void (0)}
                                                                                        className="dropdown-item text-black"
                                                                                        onClick={() => {
                                                                                            setOpenDropdownIndex(null);
                                                                                            downloadInvoice(v?.invoiceNumber?.map(item => item), v.webOrderNum)
                                                                                        }}
                                                                                    >
                                                                                        <i className="fa fa-download"></i>
                                                                                        {t('downloadAllInvoices')}
                                                                                    </a>
                                                                                </li>
                                                                            )}
                                                                        </ul>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="d-block">
                                                                <span className='text-blue cursor-pointer' onClick={() => navigateToOrderDetail(v.azureOrderNum)}>
                                                                    {v.poNumber ? v.poNumber : ''}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="d-block">Web#: {v.webOrderNum ? <span className='text-blue cursor-pointer' onClick={() => navigateToOrderDetail(v.azureOrderNum)}>{v.webOrderNum}</span> : '-'}</div>
                                                            <div className="d-block">Sales#: <span className='text-blue cursor-pointer' onClick={() => navigateToOrderDetail(v.azureOrderNum)}>{Number(v.salesOrderNum) > 0 ? v.salesOrderNum : "-"}</span> </div>
                                                        </td>
                                                        <td>{v.orderStatus ? v.orderStatus : ''}</td>
                                                        <td>{v?.trackingNumber ? v?.trackingNumber?.length > 2 ?
                                                            <a onClick={() =>
                                                                System.popup('OrderDetailViewAllTrackingPopup', {
                                                                    trackingDetails: v.trackingNumber,
                                                                    poNumber: v.poNumber,
                                                                    carrier: v?.shippingInstruction
                                                                })}
                                                            >
                                                                {t('viewAllTracking')}
                                                            </a> :
                                                            v?.trackingNumber.map((value, index) => (
                                                                <div key={index}>
                                                                    {displayTrackingNumber(value, v?.shippingInstruction)}
                                                                </div>
                                                            )) : ''}</td>
                                                        <td>{v?.invoiceNumber ? v?.invoiceNumber?.length > 2 ?
                                                            <a onClick={() =>
                                                                System.popup('OrderDetailViewInvoicesPopup', {
                                                                    invoiceData: v.invoiceNumber,
                                                                    poNumber: v.poNumber,
                                                                    orderNumber: v.webOrderNum
                                                                })}
                                                            >
                                                                {t('viewAllInvoices')}
                                                            </a> :
                                                            v.invoiceNumber.map((value, index) => (
                                                                <div key={index} className="mb-2">
                                                                    <a href={void (0)} aria-label="InvoiceGenerationlink"
                                                                        onClick={() => downloadInvoice([value], v.webOrderNum)}>
                                                                        {value && <i className='fa fa-download me-2 text-black'></i>}
                                                                        {value}
                                                                    </a>
                                                                </div>
                                                            )) : ''}</td>
                                                        <td>{v?.orderType === 'Online' ? (v.orderDate ? Helper.orderHistoryDateFormat(v.orderDate) : '') : (v.backendOrderCreatedOn ? Helper.orderHistoryDateFormat(v.backendOrderCreatedOn) : '')}</td>
                                                        <td>{v.orderTotal ? System.getFormatNumber({ amount: Number(v.orderTotal), maximumFractionDigits: 2, currency: System.getRegionCurrency(), roundOff: true }) : ''}</td>
                                                        <td>{v.orderType ? v.orderType : ''}</td>
                                                        <td>{v.doNumber ? v.doNumber?.length > 2 ?
                                                            <a onClick={() =>
                                                                System.popup('OrderReleasesPopup', {
                                                                    doNum: v.doNumber,
                                                                    poNumber: v.poNumber
                                                                })}
                                                            >
                                                                {t('viewAllReleases')}
                                                            </a> :
                                                            v.doNumber.map((value, index) => (
                                                                <div key={index}>{value}</div>
                                                            )) : ''}
                                                        </td>
                                                        {isCoreUser &&
                                                            <>
                                                                <td>{v.accountNumber ? v.accountNumber : ''}</td>
                                                                <td>{v.buyer ? v.buyer : ''}</td>
                                                            </>}
                                                    </tr>
                                                    <tr className='align-middle bg-offwhite'>
                                                        <td colSpan={19} className='p-0'>
                                                            <div className={expandedRow?.includes(v.azureOrderNum) ? "table-responsive mb-0" : "table-responsive mb-0 d-none"}>
                                                                <table className="bs5 table table-head-border-x-0 mb-4">
                                                                    <thead>
                                                                        <tr>
                                                                            <th className="w40 border-0 bg-offwhite"></th>
                                                                            {isCoreUser && <th className="w85"></th>}
                                                                            <th className="w100"><span>{t('lineItem')} <br />{System.getCurrentRegionWithType(apacAbbr) && t('number')}</span></th>
                                                                            <th className=""><span>{t('manufacturer')}</span></th>
                                                                            <th className=""><span>{t('manufacturer')} <br /> {t('partNumber')}</span></th>
                                                                            {isCoreUser && <th className=""><span>{t('customerPart')} <br />{t('number')}</span></th>}
                                                                            <th className=""><span>{t('lineStatus')}</span></th>
                                                                            <th className=""><span>{t('quantity')}</span></th>
                                                                            <th className=""><span>{t('unitPrice')}</span></th>
                                                                            <th className=""><span>{t('totalPrice')}</span></th>
                                                                            {isCoreUser && <th className=""><span>{t('customer')} <br /> {t('requestedDate')}</span></th>}
                                                                            {isCoreUser && <th className=""><span>{t('scheduled')} <br /> {t('quantity')}</span></th>}
                                                                            <th className=""><span>{t('expected')} <br />{t('deliveryDate')}</span></th>
                                                                            <th className=""><span>{t('delivery')} <br /> {t('quantity')}</span></th>
                                                                        </tr>
                                                                    </thead>
                                                                    {order?.orderItems && order?.orderItems?.length > 0 &&
                                                                        <>
                                                                            <tbody>
                                                                                {order?.orderItems?.map((val, i) => {
                                                                                    return val.processedDetails?.length <= 0 ? <tr className="align-middle" key={i + 1}>{renderOrderItem(v, val, null)}</tr> :
                                                                                        val.processedDetails.map((processItem, index) => {
                                                                                            return <tr className="align-middle" key={i}>
                                                                                                {index === 0 ? renderOrderItem(v, val, processItem) : <>
                                                                                                    {System.getCurrentRegionWithType(apacAbbr) && <td />}
                                                                                                    <td />
                                                                                                    <td />
                                                                                                    <td />
                                                                                                    {isCoreUser && <td />}
                                                                                                    <td />
                                                                                                    <td />
                                                                                                    <td />
                                                                                                    <td />
                                                                                                    <td />
                                                                                                    {isCoreUser && <td />}
                                                                                                    {isCoreUser && <td />}
                                                                                                </>}
                                                                                                <td>
                                                                                                    <table>
                                                                                                        <tr>
                                                                                                            <td>{processItem.atsDate ? Helper.orderHistoryDateFormat(processItem.atsDate) : ""}</td>
                                                                                                        </tr>
                                                                                                    </table>
                                                                                                </td>
                                                                                                <td><table>
                                                                                                    <tr>
                                                                                                        <td>{get_quantity_format(processItem.shippedQty)}</td>
                                                                                                    </tr>
                                                                                                </table>
                                                                                                </td>
                                                                                            </tr>
                                                                                        })
                                                                                })}
                                                                            </tbody>
                                                                        </>}
                                                                </table>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </ React.Fragment>
                                            )
                                        })}
                                    </tbody>
                                }
                            </table>
                        </div>
                    }
                    {order_list.orderList && order_list.orderList?.length > 0 &&
                        <Pagination pageCount={listObj.pageCount} setPageLimit={setPageLimit}
                            handlePageClick={handlePageClick} page={listObj.page - 1} limit={listObj.limit} />
                    }
                </div>
            }

            {
                !__check(['ORDER_API_CALL']).status && (Object.keys(order_list).length === 0 || order_list.orderList === undefined || order_list.orderList?.length === 0) && dateRange &&

                <div className='container'>
                    <div className='mb-3 d-flex justify-content-center'>
                        <div className='alert alert-info d-flex justify-content-center mt-3' role="alert">
                            <span>{t('sorryNoResultFound')}</span>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default OrderHistoryListing